export default function MerchantImagesController(
  $scope,
  $window,
  $state,
  $stateParams,
  $timeout,
  merchantImagesService,
  merchantService,
  NotificationService,
  UtilService,
  Lightbox,
  IMAGES,
) {
  var vm = this,
    LANDSCAPE_TYPE = 'landscape';

  vm.merchantId = $stateParams.merchantId;
  vm.merchant = $stateParams.merchant;
  vm.images = [];
  vm.cropItems = [];
  vm.sliderImages = [];
  vm.landscapeImages = [];
  vm.isLoading = false;

  vm.init = init;
  vm.deleteImage = deleteImage;
  vm.updateSortOrder = updateSortOrder;
  vm.openLandscapeLightbox = openLandscapeLightbox;
  vm.openSliderLightbox = openSliderLightbox;

  vm.landscapeImgListOps = {
    updated: false,
    update: function(event, ui) {
      // occurs before the actual model changes
      this.updated = true;
    },
    stop: function() {
      if (this.updated) {
        updateSortOrder(vm.landscapeImages);
        this.updated = false;
      }
    },
    forcePlaceholderSize: true,
    handle: 'img',
    placeholder: 'placeholder',
    'ui-floating': true,
  };

  vm.sliderImgListOps = {
    updated: false,
    update: function(event, ui) {
      // occurs before the actual model changes
      this.updated = true;
    },
    stop: function() {
      if (this.updated) {
        updateSortOrder(vm.sliderImages);
        this.updated = false;
      }
    },
    forcePlaceholderSize: true,
    handle: 'img',
    placeholder: 'placeholder',
    'ui-floating': 'auto',
  };

  vm.landscapeDzOps = {
    url: function() {
      return false;
    },
    accept: function(file, done) {
      file.rejectDimensions = function() {
        NotificationService.error('File ' + file.name + ' has invalid width or height.');
        done();
      };
      file.acceptDimensions = function() {
        onFileAdded(vm.landscapeDzMethods.getDropzone());
        done();
      };
    },
    addedfile: function(file) {},
    maxFiles: 20,
    autoProcessQueue: false,
    acceptedFiles: 'image/jpeg, image/png, image/gif',
  };

  vm.sliderDzOps = {
    url: function() {
      return false;
    },
    accept: function(file, done) {
      file.rejectDimensions = function() {
        NotificationService.error('File ' + file.name + ' has invalid width or height.');
        done();
      };
      file.acceptDimensions = function() {
        onFileAdded(vm.sliderDzMethods.getDropzone());
        done();
      };
    },
    addedfile: function(file) {},
    maxFiles: 20,
    autoProcessQueue: false,
    acceptedFiles: 'image/jpeg, image/png, image/gif',
  };

  vm.landscapeDzCallbacks = {
    thumbnail: function(file) {
      if (file.status === 'error') {
        NotificationService.error('File ' + file.name + ' has invalid format');
        return;
      }

      if (file.width < IMAGES.LANDSCAPE.MIN_WIDTH || file.height < IMAGES.LANDSCAPE.MIN_HEIGHT) {
        file.rejectDimensions();
        vm.landscapeDzMethods.removeFile(file);
        return;
      }
      file.acceptDimensions();
      vm.cropItems.push(getCropItem(IMAGES.LANDSCAPE.TYPE, file));
    },
  };

  vm.sliderDzCallbacks = {
    thumbnail: function(file) {
      if (file.status === 'error') {
        NotificationService.error('File ' + file.name + ' has invalid format');
        return;
      }

      if (file.width < IMAGES.SLIDER.MIN_WIDTH || file.height < IMAGES.SLIDER.MIN_HEIGHT) {
        file.rejectDimensions();
        vm.sliderDzMethods.removeFile(file);
        return;
      }
      file.acceptDimensions();
      vm.cropItems.push(getCropItem(IMAGES.SLIDER.TYPE, file));
    },
  };

  $scope.$watchCollection(
    'vm.cropItems',
    debounce(function() {
      if (vm.cropItems.length == 0) {
        return;
      }
      goToCrop(vm.merchantId, vm.cropItems);
    }, 600),
  );

  var listener = $scope.$on('merchant.tab.images.selected', function(event, merchant) {
    vm.merchant = merchant;
    vm.init();
  });

  function init() {
    if (!vm.merchant) {
      merchantService.getMerchantById(vm.merchantId).then(function(res) {
        if (res && res.data) {
          vm.merchant = res.data;
        }
      });
    }
    getImages();
  }

  function getImages() {
    listener();
    vm.isLoading = true;
    merchantImagesService
      .getImages(vm.merchantId)
      .then(function(res) {
        vm.images = res.data;
        fillImageTypeArrays(vm.images);
      })
      .catch(function() {
        NotificationService.error('Error getting merchant images');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function fillImageTypeArrays(images) {
    var i = 0,
      len = images.length,
      sliderImageFound = false;

    while (i < len && !sliderImageFound) {
      if (images[i].type !== LANDSCAPE_TYPE) {
        sliderImageFound = true;
      } else {
        i++;
      }
    }

    vm.landscapeImages = images.slice(0, i);
    vm.sliderImages = images.slice(i, len);
  }

  function updateSortOrder(collection) {
    var list = [];
    angular.forEach(collection, function(item, idx) {
      list.push({ id: item.id, sortOrder: 1000 - idx });
    });

    vm.isLoading = true;
    merchantImagesService
      .updateSortOrder(vm.merchantId, list)
      .then(function() {
        NotificationService.success('Sort order updated');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function deleteImage(imageId) {
    var confirmation;
    if (vm.isLoading) {
      return;
    }

    confirmation = $window.confirm('Are you sure you want to delete this image?');
    if (confirmation) {
      vm.isLoading = true;

      merchantImagesService
        .deleteImage(vm.merchantId, imageId)
        .then(function() {
          UtilService.deleteElementById(vm.images, imageId);
          fillImageTypeArrays(vm.images);
          NotificationService.success('Image deleted');
        })
        .finally(function() {
          vm.isLoading = false;
        });
    }
  }

  function debounce(callback, interval) {
    var timeout = null;
    return function() {
      $timeout.cancel(timeout);
      var args = arguments;
      timeout = $timeout(function() {
        callback.apply(this, args);
      }, interval);
    };
  }

  function getDropzoneMessageLayer(dropzone) {
    return angular.element(dropzone.element).children('.dz-message')[0];
  }

  function getCropItem(type, file) {
    return {
      sortOrder: 0,
      type: type,
      name: file.name,
      height: file.height,
      width: file.width,
      file: file,
    };
  }

  function goToCrop(merchantId, images) {
    if (!merchantId || !images) {
      return;
    }
    return $state.go('app.merchant-crop-images', { merchantId: merchantId, merchant: vm.merchant, data: images, index: 0 });
  }

  function onFileAdded(dropzone) {
    getDropzoneMessageLayer(dropzone).innerHTML =
      '<div><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate m-r-sm"></span>Processing... </div>';
    $scope.$apply();
    return false;
  }

  function openLandscapeLightbox(index) {
    Lightbox.openModal(
      vm.landscapeImages.map(function(item) {
        return { url: item.urls[0], caption: item.name };
      }),
      index,
    );
  }

  function openSliderLightbox(index) {
    Lightbox.openModal(
      vm.sliderImages.map(function(item) {
        return { url: item.urls[0], caption: item.name };
      }),
      index,
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/images/images.controller.js